var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noshow",
    d: "M26.9532 21V20.995M25 15.4C25.2608 14.5886 26.0366 14 26.9531 14C28.0836 14 29 14.8954 29 16C29 17.6068 27.2825 16.8168 27 18.5M14 23H22C24.2091 23 26 24.7909 26 27V29H10V27C10 24.7909 11.7909 23 14 23ZM22 15C22 17.2091 20.2091 19 18 19C15.7909 19 14 17.2091 14 15C14 12.7909 15.7909 11 18 11C20.2091 11 22 12.7909 22 15Z",
    stroke: "#0049A6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard7);
export default __webpack_public_path__ + "static/media/Card7.18536e96886c14c7a401479bb52bc530.svg";
export { ForwardRef as ReactComponent };